module.exports = __webpack_public_path__ + "20250721160708/img/kecheng.18499d70.png";